define('lib/channel',['require','backbone','underscore'],function(require) {
    'use strict';

    var Backbone = require('backbone');
    var _ = require('underscore');


    function MessagesMap() {}

    function Messages() {
        this.map = new MessagesMap();
        this.idCount = 0;
    }
    Messages.prototype.id = function() {
        return (++this.idCount).toString(36);
    };
    Messages.prototype.add = function(name, data, cb) {
        var message = new Message(this.id(), false, name, data, cb);
        this.map[message.id] = message;
        return message;
    };
    Messages.prototype.remove = function(id) {
        var message = this.map[id];
        delete this.map[id];
        return message;
    };

    function Message(id, ack, name, data, cb) {
        this.id = id;
        this.ack = ack;
        this.name = name;
        this.data = data;
        this.cb = cb;
    }
    Message.prototype.toJSON = function() {
        return {
            name: this.name,
            id: this.id,
            data: this.data,
            ack: +this.ack,
            cb: (this.cb) ? 1 : 0
        };
    };


    function Channel(socket) {
        this.socket = socket;

        this.messages = new Messages();

        var channel = this;

        var connectRegExp = new RegExp('\\.connect$');

        var onopen = socket.onopen;
        socket.onopen = function() {
            // console.log('SOCKET OPEN');
            if (onopen) { onopen.apply(socket, arguments); }

            if (channel.closed) {
                channel.closed = false;

                _.each(channel.messages.map, function(message) {
                    socket.send(message.toJSON());
                });

                _(channel._events).keys().filter(function(event) {
                    return connectRegExp.test(event);
                }).each(function(event) {
                    // console.log('TRIGGER CON', event);
                    channel.trigger(event);
                });
            }
        };

        var onclose = socket.onclose;
        socket.onclose = function() {
            // console.log('SOCKET CLOSE');
            channel.closed = true;
            if (onclose) { onclose.apply(socket, arguments); }
        };

        var onmessage = socket.onmessage;
        socket.onmessage = function(data) {
            if (data && data.name) { return channel._onMessage(data); }
            if (onmessage) { onmessage.call(socket, data); }
        };
    }
    _.extend(Channel.prototype, Backbone.Events);

    Channel.prototype.send = function(name, data, cb) {
        // console.log('send', name);
        if (this.closed) { return; }

        var message = this.messages.add(name, data, cb);
        this.socket.send(message.toJSON());
    };

    Channel.prototype.close = function() {
        this.socket.close();
    };

    Channel.prototype._reply = function(id, name, data) {
        // console.log('reply', id, name);
        var message = new Message(id, true, name, data);
        this.socket.send(message.toJSON());
    };

    Channel.prototype._onMessage = function(data) {
        // console.log('message', data.name, data);
        if (data.ack) {
            var message = this.messages.remove(data.id);
            if (message && message.cb) { message.cb.apply(null, data.data); }
            return;
        }
        var name = data.name;
        if (data.cb) {
            var channel = this;
            var hasListeners = this.trigger(name, data.data, function() {
                var args = Array.prototype.slice.call(arguments);
                channel._reply(data.id, name, args);
            });
            if (!hasListeners) { this._reply(data.id, name); }
        } else {
            this.trigger.apply(this, [name].concat(data.data));
            this._reply(data.id, name);
        }
    };

    return Channel;
});
